import classnames from 'classnames'
import React, { useCallback, useContext, useMemo, useState } from 'react'
import { Form } from 'react-final-form'
import { DEFAULT_REQUEST_MODEL, IRequestModel } from '../../model/RequestModel'
import { LanguageCodeMap } from '../../constants'
import { Signature } from './Pages/Signature'
import styles from './Wizard.module.css'
import { submitFormData } from '../../services/formService'
import { Loader } from '../../components/Loader'
import { localeContext } from '../../localeContext'
import ErrorIcon from '../../components/error-icon.svg'

interface IWizardProps {
  languageCode?: string,
}

interface IWizardState {
  currentPage: number,
  status: string | null,
  message: string | null,
}

const initialState: IWizardState = {
  currentPage: 0,
  status: null,
  message: null,
}

export const Wizard: React.FC<IWizardProps> = () => {
  const [state, setState] = useState<IWizardState>(initialState)

  const locale = useContext(localeContext)

  const pages = useMemo(() => [
    Signature,
  ], [])

  const nextSlide = useCallback(
    () => {
      window.scrollTo(0, 0);
      setState({ ...state, currentPage: Math.min(state.currentPage + 1, pages.length) })
    },
    [state, pages]
  )

  const previousSlide = useCallback(
    () => {
      window.scrollTo(0, 0);
      setState({ ...state, currentPage: Math.max(state.currentPage - 1, 0) })
    },
    [state]
  )

  const CurrentPage = pages[state.currentPage]

  const onSubmit = useCallback(async (values) => {
    if (state.currentPage === pages.length - 1) {

      const result = await submitFormData(LanguageCodeMap[locale], values)

      setState({ ...state, ...result })

      return result
    } else {
      nextSlide()
    }
  }, [state, pages.length, nextSlide, locale])

  // Take care of dependant validation
  const extraValidation = (values: IRequestModel) => {
    const errors: Partial<{ [N in keyof IRequestModel]: string }> = {}
    if (Object.keys(errors).length > 0) {
      return errors
    }

    return undefined
  }

  const closeModal = useCallback(
    () => {

      if ((state as any)?.["type"] === "success") {
        window.location.reload();
      }

      setState({ ...state, status: null, message: null }
      )
    },
    [state]
  )

  return (
    <div className={styles.Wizard}>
      <div className={styles.Body}>
        <Form
          onSubmit={onSubmit}
          initialValues={DEFAULT_REQUEST_MODEL}
          validate={extraValidation}
        >
          {({ handleSubmit, submitting }) => {
            return (
              <form className={styles.Form} onSubmit={handleSubmit} id={"hzmo_covid_from"}>
                <CurrentPage
                  numPages={pages.length}
                  currentPage={state.currentPage}
                  onNext={nextSlide}
                  onPrevious={previousSlide}
                />

                { submitting && (
                  <div className={classnames('modal fade show', styles.ModalWrapper)} tabIndex={-1} role='dialog'>
                    <div className='modal-dialog' role='document'>
                      <div className='modal-content'>
                        <div className='modal-body' id='dialog_text'>
                          <Loader />
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                { state.status != null && (
                  <div className={classnames('modal fade show', styles.ModalWrapper)} tabIndex={-1} role='dialog'>
                    <div className='modal-dialog' role='document'>
                      <div className='modal-content'>
                        <div className='modal-header'>
                          <h5 className='modal-title' id='dialog_heading'>
                            {
                            state.status === "Greška" && <img src={ErrorIcon} width={24} height={24} style={{marginRight: "5px", paddingBottom: "4px"}}/>
                            }
                            {state.status}
                          </h5>
                          <button onClick={closeModal} type='button' className='close' data-dismiss='modal' aria-label='Close'>
                            <span aria-hidden='true'>&times;</span>
                          </button>
                        </div>
                        <div className='modal-body' id='dialog_text'>
                          <p>{state.message}</p>
                        </div>
                        <div className='modal-footer'>
                          <button onClick={closeModal} type='button' className='btn btn-secondary' data-dismiss='modal'>Zatvori</button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </form>
            )
          }}
        </Form>
      </div>
    </div>
  )
}
